/* Fairway Construction Theme JS */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initHeader();
    initMobileNav();
    initFilterTabs();
    initGallery();
    initForm();
    triggerVisible();
  });

  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function triggerVisible() {
    setTimeout(function () {
      document.querySelectorAll('.reveal').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('visible');
      });
    }, 80);
  }

  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 80);
    }, { passive: true });
  }

  function initMobileNav() {
    var btn   = document.querySelector('.header-menu-btn');
    var nav   = document.querySelector('.mobile-nav');
    var close = document.querySelector('.mobile-nav__close');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      nav.classList.toggle('open');
      btn.classList.toggle('open');
      btn.setAttribute('aria-expanded', nav.classList.contains('open'));
    });
    function closeNav() { nav.classList.remove('open'); btn.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
    if (close) close.addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeNav); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  function initFilterTabs() {
    var tabs = document.querySelectorAll('.filter-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var filter = tab.dataset.filter || 'all';
        document.querySelectorAll('.plot-card').forEach(function (card) {
          var show = filter === 'all' || (card.dataset.status || '') === filter;
          card.style.display = show ? '' : 'none';
        });
      });
    });
  }

  function initGallery() {
    var lb = document.getElementById('fw-lightbox');
    if (!lb) return;
    var lbImg = lb.querySelector('img');
    document.querySelectorAll('.gallery__item').forEach(function (item) {
      item.addEventListener('click', function () {
        var src = item.querySelector('img') ? item.querySelector('img').src : null;
        if (!src) return;
        lbImg.src = src;
        lb.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });
    lb.querySelector('.lb-close').addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; }
  }

  function initForm() {
    var form = document.querySelector('.booking-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (!btn) return;
      var orig = btn.innerHTML;
      btn.innerHTML = '<span>Request Received — We\'ll Be In Touch</span>';
      btn.disabled = true;
      setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 5000);
    });
  }
})();
